import { ConsumerPageWidgetsHomeRoute } from 'routes/logged-in/consumer-page-widgets/ConsumerPageWidgetsHomeRoute';
import { CreateConsumerPageWidgetRoute } from 'routes/logged-in/consumer-page-widgets/CreateConsumerPageWidgetRoute';
import { EditConsumerPageWidgetRoute } from 'routes/logged-in/consumer-page-widgets/EditConsumerPageWidgetRoute';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import React, { FunctionComponent } from 'react';

export const ConsumerPageWidgetsRoute: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation();
  const match = useRouteMatch();

  return (
    <Switch location={location}>
      <Route path={`${match.path}/new`} component={CreateConsumerPageWidgetRoute} />
      <Route path={`${match.path}/edit/:id`} component={EditConsumerPageWidgetRoute} />

      <Route component={ConsumerPageWidgetsHomeRoute} />
    </Switch>
  );
};
